import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaGithub, FaLinkedin, FaTwitter, FaEnvelope, FaHeart, FaCode } from 'react-icons/fa';
import "./Footer.scss";

const Footer = () => {
    const currentYear = new Date().getFullYear();


    const socialLinks = [
      {
        name: 'GitHub',
        url: 'https://github.com/mohit200008',
        icon: FaGithub,
        color: '#333'
      },
      {
        name: 'LinkedIn',
        url: 'https://www.linkedin.com/in/mohit-l-a75076108',
        icon: FaLinkedin,
        color: '#0077b5'
      },
      {
        name: 'Twitter',
        url: 'https://twitter.com/mohitlamba12',
        icon: FaTwitter,
        color: '#1DA1F2'
      },
      {
        name: 'Email',
        url: 'mailto:mohitklamba@gmail.com',
        icon: FaEnvelope,
        color: '#EA4335'
      }
    ];
    

    return (
        <footer className="footer">
            <Container>
                <Row className="footer-content">
                    <Col lg={4} md={6} className="footer-section">
                        <div className="footer-card">
                            <h3 className="footer-title">Mohit Lamba</h3>
                            <p className="footer-description">
                                Software Engineer with 2 years of experience building enterprise database 
                                utilities using Java and Python. Experienced with full-stack development 
                                using React.js and modern web technologies.
                            </p>
                        </div>
                    </Col>
                    
                    <Col lg={4} md={6} className="footer-section">
                        <div className="footer-card">
                            <h4 className="footer-subtitle">Quick Links</h4>
                            <ul className="footer-links">
                                <li><a href="#about">About</a></li>
                                <li><a href="#experience">Experience</a></li>
                                <li><a href="#projects">Projects</a></li>
                                <li><a href="#contact">Contact</a></li>
                            </ul>
                        </div>
                    </Col>
                    
                    <Col lg={4} md={12} className="footer-section">
                        <div className="footer-card">
                            <h4 className="footer-subtitle">Connect</h4>
                            <div className="social-links">
                                {socialLinks.map((social, index) => (
                                    <a
                                        key={index}
                                        href={social.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="social-link"
                                        aria-label={social.name}
                                    >
                                        <social.icon />
                                    </a>
                                ))}
                            </div>
                        </div>
                    </Col>
                </Row>
                
                <Row>
                    <Col>
                        <div className="footer-bottom">
                            <div className="footer-divider"></div>
                            <div className="footer-copyright">
                                <span className="copyright-text">
                                    <FaCode className="code-icon" />
                                    &nbsp;with&nbsp;
                                    <FaHeart className="heart-icon" />
                                    &nbsp;by Mohit Lamba
                                </span>
                                <span className="copyright-year">© {currentYear}</span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
